import { render, staticRenderFns } from "./ShopOrderDetail.vue?vue&type=template&id=518e62d4&scoped=true"
import script from "./ShopOrderDetail.vue?vue&type=script&lang=js"
export * from "./ShopOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./ShopOrderDetail.vue?vue&type=style&index=0&id=518e62d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518e62d4",
  null
  
)

export default component.exports